export interface IModuleQuestionI18n {
	readonly locale: string;
	readonly question: string;
	readonly addSiblingLabel: string;
	readonly addDuplicateLabel: string;
}

export class ModuleQuestionI18n implements IModuleQuestionI18n {
	private _locale: string;
	private _question: string;
	private _addSiblingLabel: string;
	private _addDuplicateLabel: string;

	constructor(
		locale: string,
		question: string,
		addSiblingLabel: string,
		addDuplicateLabel: string
	) {
		this._locale = locale;
		this._question = question;
		this._addSiblingLabel = addSiblingLabel;
		this._addDuplicateLabel = addDuplicateLabel;
	}

	public get locale(): string {
		return this._locale;
	}

	public get question(): string {
		return this._question;
	}

	public get addSiblingLabel(): string {
		return this._addSiblingLabel;
	}

	public get addDuplicateLabel(): string {
		return this._addDuplicateLabel;
	}
}
